window.addEventListener("DOMContentLoaded", () => {
  customVideoPlayerSettingsWrapper();

  function customVideoPlayerSettingsWrapper() {
    let pucCustomVideoPlayer = document.querySelector(
      ".puc-custom-video-player"
    );
    if (!pucCustomVideoPlayer) {
      return;
    }

    let MobilePucCustomVideoPlayer = document.querySelector(
      ".mobile-puc-custom-video-player"
    );

    if (!MobilePucCustomVideoPlayer) {
      return;
    }

    let pucCustomVideoSound = document.getElementsByClassName(
      "puc-custom-video-sound"
    );
    let windowScreenWidth = window.screen.width;

    /*
         // Play/Pause button
        let playPauseButton = document.getElementById("playPauseButton");
        
        // Play/Pause functionality
        playPauseButton.addEventListener('click', () => {
            if (windowScreenWidth >= 951 && pucCustomVideoPlayer) {
                if (pucCustomVideoPlayer.paused) {
                    pucCustomVideoPlayer.play();
                    playPauseButton.textContent = "Pause Video";
                } else {
                    pucCustomVideoPlayer.pause();
                    playPauseButton.textContent = "Play Video";
                }
            } else if (windowScreenWidth <= 950 && MobilePucCustomVideoPlayer) {
                if (MobilePucCustomVideoPlayer.paused) {
                    MobilePucCustomVideoPlayer.play();
                    playPauseButton.textContent = "Pause Video";
                } else {
                    MobilePucCustomVideoPlayer.pause();
                    playPauseButton.textContent = "Play Video";
                }
            }
        });

       // Play/Pause button Mobile
        let playPauseButtonMob = document.getElementById("playPauseButtonMob");
        
        // Play/Pause functionality mobile
        playPauseButtonMob.addEventListener('click', () => {
            if (windowScreenWidth >= 951 && pucCustomVideoPlayer) {
                if (pucCustomVideoPlayer.paused) {
                    pucCustomVideoPlayer.play();
                    playPauseButton.textContent = "Pause Video";
                } else {
                    pucCustomVideoPlayer.pause();
                    playPauseButton.textContent = "Play Video";
                }
            } else if (windowScreenWidth <= 950 && MobilePucCustomVideoPlayer) {
                if (MobilePucCustomVideoPlayer.paused) {
                    MobilePucCustomVideoPlayer.play();
                    playPauseButton.textContent = "Pause Video";
                } else {
                    MobilePucCustomVideoPlayer.pause();
                    playPauseButton.textContent = "Play Video";
                }
            }
        });
*/
    desktopOnLoadCheck();

    function desktopOnLoadCheck() {
      // (DESKTOP) on load actions
      if (windowScreenWidth >= 951 && pucCustomVideoPlayer) {
        // on load play video
        pucCustomVideoPlayer.autoplay;
        pucCustomVideoPlayer.play();
        pucCustomVideoPlayer.muted = true;

        // when video finishes loop play
        pucCustomVideoPlayer.addEventListener("ended", videoLoopPlay, false);

        function videoLoopPlay() {
          pucCustomVideoPlayer.play();
        }

        onLoadHideSound();
      }
    }

    mobileOnLoadCheck();

    function mobileOnLoadCheck() {
      // (MOBILE) on load actions
      if (windowScreenWidth <= 950 && MobilePucCustomVideoPlayer) {
        // on load play video
        MobilePucCustomVideoPlayer.autoplay;
        MobilePucCustomVideoPlayer.play();
        MobilePucCustomVideoPlayer.muted = true;

        // when video finishes loop play
        MobilePucCustomVideoPlayer.addEventListener(
          "ended",
          videoLoopPlay,
          false
        );

        function videoLoopPlay() {
          MobilePucCustomVideoPlayer.play();
        }

        onLoadHideSound();
      }
    }

    function onLoadHideSound() {
      for (let i = 0; i < pucCustomVideoSound.length; i++) {
        // on load hide icon
        if (pucCustomVideoSound[i].hasAttribute("puc-custom-video-control")) {
          let soundIcon = pucCustomVideoSound[i].getAttribute(
            "puc-custom-video-control"
          );

          if (soundIcon == "sound-on") {
            pucCustomVideoSound[i].style.display = "block";
          }
          if (soundIcon == "sound-off") {
            pucCustomVideoSound[i].style.display = "none";
          }
        }
      }
    }

    // on click mute/activate sound
    document.addEventListener("click", function (clicked) {
      if (clicked.target.parentNode.hasAttribute("puc-custom-video-control")) {
        // clicked icon attribute
        let clickedSoundIconAttribute = clicked.target.parentNode.getAttribute(
          "puc-custom-video-control"
        );

        for (let j = 0; j < pucCustomVideoSound.length; j++) {
          // looped icons attribute
          let soundIconAttr = pucCustomVideoSound[j].getAttribute(
            "puc-custom-video-control"
          );

          // (DESKTOP) on click mute/activate sound
          if (windowScreenWidth >= 951 && pucCustomVideoPlayer) {
            if (clickedSoundIconAttribute == "sound-on") {
              pucCustomVideoPlayer.muted = false;
              pucCustomVideoSound[j].style.display = "none";

              if (soundIconAttr == "sound-off") {
                pucCustomVideoSound[j].style.display = "block";
              }
            }
            if (clickedSoundIconAttribute == "sound-off") {
              pucCustomVideoPlayer.muted = true;
              pucCustomVideoSound[j].style.display = "none";

              if (soundIconAttr == "sound-on") {
                pucCustomVideoSound[j].style.display = "block";
              }
            }
          }

          // (MOBILE) on click mute/activate sound
          if (windowScreenWidth <= 950 && MobilePucCustomVideoPlayer) {
            if (clickedSoundIconAttribute == "sound-on") {
              MobilePucCustomVideoPlayer.muted = false;
              pucCustomVideoSound[j].style.display = "none";

              if (soundIconAttr == "sound-off") {
                pucCustomVideoSound[j].style.display = "block";
              }
            }
            if (clickedSoundIconAttribute == "sound-off") {
              MobilePucCustomVideoPlayer.muted = true;
              pucCustomVideoSound[j].style.display = "none";

              if (soundIconAttr == "sound-on") {
                pucCustomVideoSound[j].style.display = "block";
              }
            }
          }
        }
      }
    });
  }
});
